module.exports = __webpack_public_path__ + "img/LOGO.417f5084.png";